export const ApplicationIcon = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
      fill="#2E7D32"
    />
    <path
      d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
      stroke="#E5E7EB"
    />
    <g clipPath="url(#clip0_48_507)">
      <path
        d="M26 20C24.3453 20 23 21.3453 23 23V41C23 42.6547 24.3453 44 26 44H38C39.6547 44 41 42.6547 41 41V27.5H35C34.1703 27.5 33.5 26.8297 33.5 26V20H26ZM35 20V26H41L35 20ZM33.125 39.125C33.125 39.7484 32.6234 40.25 32 40.25C31.3766 40.25 30.875 39.7484 30.875 39.125V34.3391L29.4219 35.7922C28.9812 36.2328 28.2687 36.2328 27.8328 35.7922C27.3969 35.3516 27.3922 34.6391 27.8328 34.2031L31.2078 30.8281C31.6484 30.3875 32.3609 30.3875 32.7969 30.8281L36.1719 34.2031C36.6125 34.6438 36.6125 35.3562 36.1719 35.7922C35.7312 36.2281 35.0188 36.2328 34.5828 35.7922L33.1297 34.3391V39.125H33.125Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_48_507">
        <path d="M23 20H41V44H23V20Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ApplicationIcon;
